var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vue-mermaid',{staticClass:"mermaid align-items-center d-flex justify-content-center",attrs:{"nodes":_vm.data,"type":"graph LR"},on:{"nodeClick":_vm.editNode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }